import React, { memo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import CalendarSvg from 'images/v5/icons/calendar.svg';
import Button from 'layout/atoms/Button/Button';
import CalendarRange from 'layout/atoms/CalendarRange/CalendarRange';
import Dropdown from 'layout/atoms/Dropdown/Dropdown';
import InputLabel from 'layout/atoms/InputLabel';
import Label from 'layout/atoms/Label';
import Modal from 'layout/atoms/Modal/Modal';
import Grid from 'layout/molecules/Grid/Grid';
import { useAppDispatch } from 'store/index';
import { closeModal, selectModalByName } from 'store/layoutSlice';
import { selectOrdersCreatorStatus, setOrderDeliveryDate } from 'store/ordersCreatorSlice';
function SetOrderDeliveryDate() {
    var _a;
    const { t } = useTranslation(['orders', 'common']);
    const history = useHistory();
    const dispatch = useAppDispatch();
    const modalData = (_a = useSelector(selectModalByName('setOrderDeliveryDate'))) === null || _a === void 0 ? void 0 : _a.data;
    const status = useSelector(selectOrdersCreatorStatus);
    const saving = status.setOrderDeliveryDate === 'loading';
    const [form, setForm] = useState({
        orderId: modalData.orderId,
        orderDeliveryDate: null,
    });
    const handleDateChange = () => (startDate) => {
        setForm(Object.assign(Object.assign({}, form), { orderDeliveryDate: startDate }));
    };
    const handleSubmit = () => {
        if (!form.orderDeliveryDate)
            return;
        dispatch(setOrderDeliveryDate({
            orderId: form.orderId,
            orderDeliveryDate: form.orderDeliveryDate.toISOString(),
        }))
            .unwrap()
            .then(() => {
            dispatch(closeModal({ name: 'setOrderDeliveryDate' }));
            history.push(`/orders/${form.orderId}`);
        });
    };
    return (React.createElement(Modal, { alwaysScroll: true, name: "setOrderDeliveryDate", size: "xs", header: React.createElement(Label, { weight: "strong" },
            React.createElement(CalendarSvg, null),
            t('SET_ORDER_DELIVERY_DATE_HEADER')) },
        React.createElement(Grid, { columns: 1, gap: 12 },
            React.createElement(InputLabel, { text: t('SET_ORDER_DELIVERY_DATE_LABEL') }),
            React.createElement(Dropdown, { closeOnClick: false, shape: "block", trigger: React.createElement(Button, { shape: "block", theme: "border", leftIcon: React.createElement(CalendarSvg, null) }, form.orderDeliveryDate ? `${form.orderDeliveryDate.format('DD.MM.YYYY')}` : '') },
                React.createElement(CalendarRange, { startDate: form.orderDeliveryDate, onDateChange: handleDateChange(), singleDate: true })),
            React.createElement(Button, { color: "primary", onClick: handleSubmit, disabled: !form.orderDeliveryDate, loading: saving }, t('common:confirm')))));
}
export default memo(SetOrderDeliveryDate);
